import React from 'react'
import styles from '../ModulosPagoTienda/stylesPagoTienda.module.sass'
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito'
import { MenuCredito } from 'components/menuCredito'
import { FormasPagoTienda, PagoTiendaPrint } from '../ModulosPagoTienda'

export default function PagoTiendaMovil(props) {
    const {
        payCard,
        barCode,
        idClaro,
        handleImprimir,
        isMobile
    } = props

    return (
        <>
            <HeaderMobileCredito title={"Pagar en Tienda"} type="backFull" />

            <div className={`container no-printme ${styles?.no_printme}`}>
                <div className={styles?.contCards}>

                    <MenuCredito />

                    <div className={styles?.contArrayCards}>

                        <FormasPagoTienda
                            payCard={payCard}
                            barCode={barCode}
                            idClaro={idClaro}
                            handleImprimir={handleImprimir}
                            isMobile={isMobile}
                        />

                    </div>

                </div>
            </div>

            <PagoTiendaPrint
                payCard={payCard}
                barCode={barCode}
                idClaro={idClaro}
            />
        </>
    )
}